import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const MoneyWeek: Site = {
  id: 'moneyweek',
  logo: 'svg/moneyweek.svg',
  label: 'MoneyWeek',
  analyticsName: 'moneyweek',
  hostname: 'moneyweek.com',
  platform: 'progressive',
  selector: `${progressiveVanillaSelector}, .polaris__app a`,
};
